import { useState } from "react"
import { Form } from "antd"
import { formatTimeOffPayload } from "../utils/scheduleTimeOffHelpers"

/**
 * Custom hook to manage Schedule Time Off form state and handlers
 * @param {Function} onSave - Handler for save action
 * @param {Function} onSaveAndAddNew - Handler for save and add new action
 * @param {Function} onCancel - Handler for cancel action
 * @returns {Object} Form instance, state, and handlers
 */
const useScheduleTimeOffForm = (onSave, onSaveAndAddNew, onCancel) => {
  const [form] = Form.useForm()
  const [isPartOfDay, setIsPartOfDay] = useState(false)
  const [showScheduledTimeOff, setShowScheduledTimeOff] = useState(false)

  // Watch form values to enable/disable save buttons
  const startDate = Form.useWatch("startDate", form)
  const endDate = Form.useWatch("endDate", form)

  const isSaveEnabled = startDate && endDate

  const handleCancel = () => {
    form.resetFields()
    setIsPartOfDay(false)
    setShowScheduledTimeOff(false)
    onCancel()
  }

  const handleFinish = (values) => {
    const payload = formatTimeOffPayload(values, isPartOfDay)
    onSave(payload)
    handleCancel()
  }

  const handleSaveAndAddNew = () => {
    form.validateFields().then((values) => {
      const payload = formatTimeOffPayload(values, isPartOfDay)
      onSaveAndAddNew(payload)
      form.resetFields()
      setIsPartOfDay(false)
    })
  }

  return {
    form,
    isPartOfDay,
    setIsPartOfDay,
    showScheduledTimeOff,
    setShowScheduledTimeOff,
    isSaveEnabled,
    handleCancel,
    handleFinish,
    handleSaveAndAddNew
  }
}

export default useScheduleTimeOffForm
